import Dexie from 'dexie'

const db = new Dexie('TestResult');
db.version(1).stores({
    results: "++id, score, createdAt"
});

class TestResultRepository {

    constructor() {
    }

    addResult(score, createdAt) {
        db.results.add(
            score,
            createdAt
        );
    }

    getResults() {
        return new Promise((resolve, reject) => {

            db.results.toArray()
                .then((results) => {
                    resolve(results)
                });
        })
    }
}

const resultRepo = new TestResultRepository();

export default resultRepo;